import { render, staticRenderFns } from "./wares-route.vue?vue&type=template&id=1fbbdc0d&scoped=true"
import script from "./wares-route.vue?vue&type=script&lang=js"
export * from "./wares-route.vue?vue&type=script&lang=js"
import style0 from "./wares-route.vue?vue&type=style&index=0&id=1fbbdc0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbbdc0d",
  null
  
)

export default component.exports